import { render, staticRenderFns } from "./BiomassMapDetails.vue?vue&type=template&id=64116748&scoped=true&"
import script from "./BiomassMapDetails.vue?vue&type=script&lang=js&"
export * from "./BiomassMapDetails.vue?vue&type=script&lang=js&"
import style0 from "./BiomassMapDetails.vue?vue&type=style&index=0&id=64116748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64116748",
  null
  
)

export default component.exports